import { PlanGetUseCase } from '../../../application';

export default class PlanGetService {
    constructor() {}

    async execute(event) {
        const request = await PlanGetUseCase(event);

        return request;
    }
}
